import HostedMac_Img from "public/hosted-mac/hosted-mac.png";

export const WHY_ONEMIND_CONSTANTS = {
  title: "Use Cases ",
  points: [
    {
      label: "Inference Serving",
      text: "Run real-time vision or NLP models in production.",
    },
    {
      label: "Model Training",
      text: "Build and train custom AI/ML models with flexible scaling.",
    },
    {
      label: "Generative AI Workloads",
      text: "Handle compute-heavy image, video, and text generation.",
    },
    {
      label: "3D Rendering",
      text: "Accelerate visualization, digital twin, or VFX workloads.",
    },
    {
      label: "Remote Workstations",
      text: "Deliver virtual desktops with GPU acceleration for creatives.",
    },
    {
      label: "Video Analytics",
      text: "Process streams for enhancement, detection, or classification.",
    },
  ],
  image: HostedMac_Img,
};
